<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">รายงานปัญหาขนส่ง</h1>
                    <p class="text-white pb-3 px-3">สรุปรายงานพัสดุที่ติดปัญหา และนำเข้า ส่งออก ไฟล์สถานะพัสดุที่ติดปัญหาต่างๆ</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="reportParcel.busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <SearchParcel :search="search" :reportParcel="reportParcel" />
                        <SearchCollapse :search="search" />
                        <TabParcel :search="search" :reportParcel="reportParcel"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import SearchParcel from '@/components/custom/reportParcel/SearchParcel'
import SearchCollapse from '@/components/custom/reportParcel/SearchCollapse'
import TabParcel from '@/components/custom/reportParcel/TabParcel'

export default {
    name: "reportparcel",
    components:{
        SearchParcel,
        SearchCollapse,
        TabParcel
    },
    data(){
        return {
            reportParcel:{
                busy: true,
                category: [{ id: null , category_name: 'ทั้งหมด' }],
                items:[],
            },
            search: {
                date:{
                    startDate: moment().subtract(1, 'months').format("YYYY-MM-DD"),
                    endDate: moment().format("YYYY-MM-DD"),
                },
                courierTrackingCode: null,
                sender: null,
                dest: null,
                categoryId: null,
                collapseSearch: false,
                isLoadSearch: false,
            },
        }
    }
};
</script>